var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('wz-loader',{scopedSlots:_vm._u([{key:"brand",fn:function(){return [_c('CrystalLogo',{attrs:{"size":36}}),_c('span',{staticClass:"app-loader-name"},[_vm._v("Crystal")])]},proxy:true}],null,false,4272531578)}):_vm._e(),_c('router-view'),_c('DocumentComplianceModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }